import {Box, Typography, Button} from "@mui/material";

interface EmailVerificationNoticeProps {
  onClick: () => void;
}

export function EmailVerificationNotice({
  onClick,
}: EmailVerificationNoticeProps) {
  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography
        color="primary.main"
        variant="body2"
        component="div"
        sx={{
          textAlign: "center",
          mb: 1,
        }}
      >
        確認メールをお送りしました。
        <br />
        メール内のリンクをクリックして登録を完了してください。
        <br />
        迷惑メールに分類されている事がありますのでご確認下さい。
      </Typography>
      <Box>
        <Button
          onClick={onClick}
          variant="contained"
          size="small"
          sx={{ fontSize: "0.875rem", mb: 5 }}
        >
          確認リンクを再送
        </Button>
      </Box>
      <Typography
        color="textSecondary"
        variant="body2"
        component="div"
        sx={{
          textAlign: "center",
          mb: 1,
        }}
      >
        確認リンクをクリックしても画面に変化がない場合は、<br />お手数ですがページを再読み込み（リロード）してください。
      </Typography>
    </Box>
  );
}
